"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RegimePurposeScopesConfig = exports.ConsentChange = exports.TrackingPurpose = exports.ConsentTokenPayload = exports.ConsentPreferencesBody = exports.FullTrackingConsentDetailsWithNulls = exports.FullTrackingConsentDetails = exports.TrackingConsentOptionalData = exports.TrackingConsentDetails = exports.CoreTrackingConsentDetails = exports.TrackingConsentWithNulls = exports.TrackingConsent = exports.TrackingPurposesConfig = exports.DefaultConsentConfig = exports.TrackingPurposesTypes = exports.TrackingPurposeDetails = exports.UserPrivacySignal = exports.DefaultConsentConfigValue = exports.AutoOptOutForGPC = exports.AutoOptOutForDNT = exports.AutoOptOutForGDPR = exports.AutoOptOut = exports.BooleanString = exports.LogLevel = exports.ConsoleSafeLogLevel = void 0;
// external
const t = __importStar(require("io-ts"));
// main
const type_utils_1 = require("@transcend-io/type-utils");
// local
const enums_1 = require("./enums");
/** Console-safe log levels */
exports.ConsoleSafeLogLevel = t.keyof({
    info: null,
    log: null,
    warn: null,
    debug: null,
    error: null,
    trace: null,
    // meta-levels:
    group: null,
    groupCollapsed: null,
    groupEnd: null,
});
/** Airgap log levels */
exports.LogLevel = t.union([exports.ConsoleSafeLogLevel, t.literal('fatal')]);
/** A boolean value represented as either `'on'` or `'off'` */
exports.BooleanString = t.keyof({
    on: null,
    off: null,
});
/** Special `defaultConsent` automatic opt-out value for any potential reason */
exports.AutoOptOut = t.literal('Auto');
/** Special `defaultConsent` automatic opt-out value for GDPR-protected users */
exports.AutoOptOutForGDPR = t.literal('AutoGDPR');
/**
 * Special `defaultConsent` automatic opt-out value for users with DNT enabled.
 * Note that DNT is enabled by default for some browsers.
 */
exports.AutoOptOutForDNT = t.literal('AutoDNT');
/**
 * Special `defaultConsent` automatic opt-out value for users with GPC enabled.
 */
exports.AutoOptOutForGPC = t.literal('AutoGPC');
/** Potential values for `defaultConsent` config token list */
exports.DefaultConsentConfigValue = t.union([
    t.boolean,
    exports.AutoOptOut,
    exports.AutoOptOutForGDPR,
    exports.AutoOptOutForDNT,
    exports.AutoOptOutForGPC,
    exports.BooleanString,
]);
/** User-configurable user agent privacy signal */
exports.UserPrivacySignal = t.union([
    /** Global Privacy Control */
    t.literal('GPC'),
    /** Do Not Track */
    t.literal('DNT'),
]);
/** Tracking purpose metadata */
exports.TrackingPurposeDetails = t.intersection([
    t.type({
        /** Tracking purpose name */
        name: t.string,
        /** Tracking purpose description (used in Consent Manager UI) */
        description: t.string,
        /** Tracking purpose default consent (default: false) */
        defaultConsent: exports.DefaultConsentConfigValue,
        /**
         * Is this a first-order tracking purpose? If false, this is a
         * second-order tracking purpose that should only be used for
         * request overrides.
         *
         * This parameter previously meant:
         *   Show tracking purpose in consent manager UI.
         *
         * Default value: true
         */
        showInConsentManager: t.boolean,
        /** Allow user to configure their consent for this purpose (default: true) */
        configurable: t.boolean,
        /** Is tracking purpose "essential" - i.e. consent is mandatory / equivalent to 'essential' permission (default: false) */
        essential: t.boolean,
    }),
    t.partial({
        /** Tracking type */
        trackingType: t.string,
        /** Respected opt-out privacy signals */
        optOutSignals: t.array(exports.UserPrivacySignal),
    }),
]);
/** Tracking purposes types configuration */
exports.TrackingPurposesTypes = t.record(t.string, exports.TrackingPurposeDetails);
/** Fully-resolved `defaultConsent` config */
exports.DefaultConsentConfig = t.record(t.string, exports.DefaultConsentConfigValue);
/** Tracking purposes configuration */
exports.TrackingPurposesConfig = t.intersection([
    t.type({
        /** Inherit default tracking purposes config */
        useDefault: t.boolean,
        types: exports.TrackingPurposesTypes,
    }),
    t.partial({
        defaultConsent: t.union([exports.DefaultConsentConfigValue, exports.DefaultConsentConfig]),
    }),
]);
exports.TrackingConsent = t.intersection([
    t.partial({
        Essential: t.literal(true),
        Unknown: t.literal(false),
    }),
    t.record(t.string, t.union([t.boolean, t.undefined])),
]);
exports.TrackingConsentWithNulls = t.record(t.string, t.union([t.boolean, t.undefined, t.null]));
const TCFReservedMetadata = t.partial({
    tcString: t.string,
});
const ReservedMetadata = t.partial({
    tcmp: t.partial({
        tcf: TCFReservedMetadata,
    }),
});
exports.CoreTrackingConsentDetails = t.intersection([
    t.type({
        /**
         * Was tracking consent confirmed by the user?
         * If this is false, the consent was resolved from defaults & is not yet confirmed
         */
        confirmed: t.boolean,
        /** Consent resolution/last-modified timestamp (ISO 8601) */
        timestamp: t.string,
    }),
    t.partial({
        /** Has the consent been updated (including no-change confirmation) since default resolution */
        updated: t.boolean,
        /** Whether or not the UI has been shown to the end-user (undefined in older versions of airgap.js) */
        prompted: t.boolean,
        /** Arbitrary metadata that customers want to be associated with consent state */
        metadata: t.intersection([ReservedMetadata, t.UnknownRecord]),
        /** When the metadata was last updated */
        metadataTimestamp: t.string,
    }),
]);
exports.TrackingConsentDetails = t.intersection([
    exports.CoreTrackingConsentDetails,
    t.type({
        /** Tracking consent config */
        purposes: exports.TrackingConsent,
    }),
]);
exports.TrackingConsentOptionalData = t.partial({
    /** Transparency Consent (TCF) String */
    tcf: t.string,
    /** US Privacy (USP) String */
    usp: t.string,
    /** Global Privacy Platform (GPP) String */
    gpp: t.string,
    /** Consent Manager View State */
    viewState: (0, type_utils_1.valuesOf)(enums_1.ViewState),
    /** Airgap Version */
    airgapVersion: t.string,
});
exports.FullTrackingConsentDetails = t.intersection([
    exports.TrackingConsentDetails,
    exports.TrackingConsentOptionalData,
]);
exports.FullTrackingConsentDetailsWithNulls = t.intersection([
    exports.CoreTrackingConsentDetails,
    exports.TrackingConsentOptionalData,
    t.type({
        /** Tracking consent config */
        purposes: exports.TrackingConsentWithNulls,
    }),
]);
exports.ConsentPreferencesBody = t.type({
    /** token containing encrypted identifier */
    token: t.string,
    /** consent partition (defaults to bundle id) */
    partition: t.string,
    /** user consent */
    consent: exports.TrackingConsentDetails,
});
exports.ConsentTokenPayload = t.intersection([
    t.type({
        encryptedIdentifier: t.string,
    }),
    t.partial({
        deprecatedEncryptedIdentifiers: t.array(t.string),
    }),
]);
/** Tracking purpose */
exports.TrackingPurpose = t.union([
    t.keyof(enums_1.SpecialTrackingPurpose),
    t.string,
]);
/** Tracking consent change diffs */
exports.ConsentChange = t.record(exports.TrackingPurpose, t.boolean);
/** Regime purpose scopes configuration */
exports.RegimePurposeScopesConfig = t.array((0, type_utils_1.FixedLengthArray)(2, 2, t.array(t.string)));
/* eslint-enable max-lines */
//# sourceMappingURL=core.js.map